import { render, staticRenderFns } from "./ReminderMailManageView.vue?vue&type=template&id=418665cd&scoped=true&"
import script from "./ReminderMailManageView.vue?vue&type=script&lang=js&"
export * from "./ReminderMailManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418665cd",
  null
  
)

export default component.exports